import { fetchApi } from '../baseApi';
import { PaidPayment } from 'src/models/payment';
import { acscriptsAddress } from 'src/appconfig';

export function submitPaidProducts(paidProducts: PaidPayment) {
    return new Promise((resolve, reject) => {
        fetchApi(`api/registrations/submit_paid_products`, 'POST', paidProducts).then((result) => {
            resolve(result);
        }).catch((e) => {
            reject(new Error('Cannot submit paid products!'));
        });
    });
}

export function getPaymentProducts () {
    return new Promise((resolve, reject) => {
        fetchApi(`api/payment_products`, 'GET', undefined, acscriptsAddress.Vendor).then((products) => {
            resolve(products);
        }).catch(() => {
            reject(new Error('Cannot get payment products!'));
        });
    });
}


// WEBPACK FOOTER //
// ./src/api/payment/index.ts